module.exports = __webpack_public_path__ + "resources/mts-logo.png";